/**
 * Destinations whose bookings MUST carry full passport details (number +
 * expiry) for every passenger — enforced by this funnel regardless of any
 * Odyssea-side "passport required" toggle the operators may flip while
 * working on group bookings (Ran, 2026-07-20: Azerbaijan bookings must never
 * be created without passport numbers).
 *
 * This mirrors flying.co.il's `passportMandatoryDests.ts` — both funnels book
 * through the SAME dynPack API, so the rules and the field names sent in the
 * payload (passportNum / passportExp) are deliberately identical. Keep the
 * two lists in sync.
 *
 * Adding a destination = one entry here.
 */
export const PASSPORT_MANDATORY_DESTS = ['BAK', 'GYD'];

export const isPassportMandatoryDest = (code) => !!code
  && PASSPORT_MANDATORY_DESTS.includes(String(code).trim().toUpperCase());

/**
 * A usable passport number: 5-15 alphanumerics. Spaces and dashes are
 * tolerated (people copy them off the document) but don't count toward the
 * length, so "x" / "123" placeholders are rejected.
 */
export const isValidPassportNumber = (raw) => {
  const cleaned = String(raw == null ? '' : raw).replace(/[\s-]/g, '');
  return /^[A-Za-z0-9]{5,15}$/.test(cleaned);
};

/**
 * A usable passport expiry: a parseable date strictly in the future (a
 * passport expiring today can't board). `dayjs` is passed in by the caller so
 * this module stays dependency-free and unit-testable.
 */
export const isValidPassportExpiry = (value, dayjs, format = 'DD-MM-YYYY') => {
  if (!value || !String(value).trim()) return false;
  const exp = dayjs(value, format, true).isValid()
    ? dayjs(value, format, true)
    : dayjs(value);
  return exp.isValid() && exp.isAfter(dayjs(), 'day');
};
